import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Comments from './components/Comments';
import About from './components/About';
import Cards from './components/Cards';
import Carousel from './components/Carousel';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Faq from './components/Faq';
import Topics from './components/Topics';
import Media from './components/Media';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Comments />
        <About />
        <Cards />
        <Carousel />
        <AppSection />
        <IndexSection />
        <Contact />
        <Updates />
        <Ranking />
        <Faq />
        <Topics />
        <Media />
      </main>
      <Footer />
    </>
  );
}